import ApiSlackNew from "../../../../../core/gd/api/integrations/slack-new";

export default function slackSettings_connect() {

    gd.utils.openCenteredWindow(ApiSlackNew.connectUrl, 'slack-connect', 600, 600);


}
